<template>
  <mobile-token-login v-if="isMobile" />
  <desktop-token-login v-else />
</template>

<script>
  import { isMobile } from 'mobile-device-detect'
  import MobileTokenLogin from '../../mobile/login/TokenLogin'
  import DesktopTokenLogin from '../../desktop/login/TokenLogin'

  export default {
    name: 'common-token-login',
    components: {
      'mobile-token-login': MobileTokenLogin,
      'desktop-token-login': DesktopTokenLogin
    },
    data () {
      return {
        isMobile
      }
    }
  }
</script>
